<template>
  <b-modal
    :id="id"
    :title="'Abonar monedero'"
    ok-title="Abonar"
    cancel-title="Cancelar"
    @ok="submit"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="Monto">
        <b-input-group prepend="$">
          <b-form-input
            v-model.number="amount"
            type="number"
            min="0"
            step="0.01"
            required
          />
        </b-input-group>
      </b-form-group>

      <b-form-group label="Nota (opcional)">
        <b-form-input
          v-model="note"
          placeholder="Ej. Recarga manual"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'WalletCreditModal',
  props: { id: { type: String, default: 'wallet-credit-modal' } },
  data() { return { amount: null, note: '' } },
  methods: {
    submit() {
      if (!this.amount || this.amount <= 0) return
      this.$emit('confirm', { amount: this.amount, note: this.note })
      this.amount = null; this.note = ''
    },
  },
}
</script>
